import { render, staticRenderFns } from "./TiptapLinkBubble.vue?vue&type=template&id=d81995e0"
import script from "./TiptapLinkBubble.vue?vue&type=script&lang=ts"
export * from "./TiptapLinkBubble.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports